import ModalInformation from "@/app/components/ui/Modals/Information";
import { BiLoader } from "react-icons/bi";
import { FaStackOverflow } from "react-icons/fa6";

const IsOverbookingAllowedModal = () => {
  return (
    <ModalInformation
      modalId="IS_OVERBOOKING_ALLOWED_MODAL"
      backdropBlur
      title={
        <div className="flex justify-start items-center gap-x-2">
          <span className="text-xl">
            <FaStackOverflow />
          </span>
          <span>Checking Overbooking</span>
        </div>
      }
    >
      <div className="flex flex-col justify-center items-center w-full h-full">
        <p className="text-slate-600">
          Please wait while we check if the overbooking is allowed or not for these booking overbooking filters.
        </p>
        <div>
          <BiLoader className="w-6 h-6 text-blue-600 animate-spin" />
        </div>
      </div>
    </ModalInformation>
  );
};

export default IsOverbookingAllowedModal;
